import style from '@aytm/app/stats/page/data-quality-report/styles/FilterNote.module.scss'

// Below T0 the report covers the whole sample whatever the stats-page filter selects, so a reader
// arriving with a filter on is told why its figures don't match the filtered charts.
const FilterNote = () => (
  <div data-testid="stat-dqr-filter-note" className={style.note} role="note">
    <i className={`${style.icon} icon-aytmfd-filter-v2`} aria-hidden="true" />
    <span>
      <b>Your filters don&apos;t apply here.</b> This report always covers your whole sample.
    </span>
  </div>
)

FilterNote.displayName = 'FilterNote'
export default FilterNote
